<template>
  <b-modal ref="modal" size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true">
    <b-form>
      <b-row align-v="center" class="pb-15 pt-10">
        <b-col cols="11" class="p-0">
          <h5 class="modal-title">{{ title }}</h5>
        </b-col>
        <b-col cols="1">
          <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close" @click="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </b-col>
      </b-row>
      <b-row class="pb-10 border-style">
        <b-col cols="4">
          <span class="header-text">First name</span>
          <b-form-input type="text" class="bg required test-color" v-model="selectedMember.firstName" placeholder="Enter name" v-validate="{ required: true, regex: /^[A-Za-z- ]+$/ }" name="firstname" v-bind:class="{ input: true, 'is-danger': errors.has('firstname') }"></b-form-input>
          <span v-if="errors.has('firstname')" class="error-style">
            <span v-if="errors.first('firstname') == `The firstname field format is invalid.`">Alphabetic entries only are allowed</span>
            <span v-if="errors.first('firstname') == `The firstname field is required.`" class="error-style">First name is required</span>
          </span>
        </b-col>
        <b-col cols="4">
          <span class="header-text">Last Name</span>
          <b-form-input type="text" class="bg required test-color" v-model="selectedMember.lastName" placeholder="Enter name" v-validate="{ required: true, regex: /^[A-Za-z- ]+$/ }" name="lastName" v-bind:class="{ input: true, 'is-danger': errors.has('lastName') }"></b-form-input>
          <span v-if="errors.has('lastName')" class="error-style">
            <span v-if="errors.first('lastName') == `The lastName field format is invalid.`">Alphabetic entries only are allowed</span>
            <span v-if="errors.first('lastName') == `The lastName field is required.`" class="error-style">Last name is required</span>
          </span>
        </b-col>
        <b-col cols="4">
          <span class="header-text">Role</span>
          <span v-if="modalType === 'add'"></span>
          <b-form-select class="modal-custom-select select-arrow" v-validate="'required'" v-model="selectedMember.userRole" name="role" v-bind:class="{ input: true, 'is-danger': errors.has('role') }" :disabled="modalType === 'edit'">
            <option value disabled>Select</option>
            <option value="Pi" :disabled="activePI || modalType === 'edit'">Principal Investigator</option>
            <option value="SubPi">Sub-Investigator</option>
            <option value="StudyCoordinator">Study Coordinator</option>
            <option value="HomeHealth">Home Health</option>
            <option value="SiteDataLock">Site - Data Lock</option>
            <option value="CallCenter">Call Center</option>
            <option value="Rater">Rater</option>
          </b-form-select>
          <span v-if="errors.has('role')" class="error-style">Please select valid role.</span>
        </b-col>
      </b-row>
      <b-row class="pb-10 border-style">
        <b-col cols="4">
          <span class="header-text">Email address</span>
          <b-form-input type="email" class="required test-color" v-model="selectedMember.username" placeholder="Enter Email" v-validate="'required|email'" name="emailID" v-bind:class="{ input: true, 'is-danger': errors.has('emailID') }" :disabled="modalType === 'edit'"></b-form-input>
          <span v-if="errors.has('emailID')" class="error-style">Please enter valid email address.</span>
        </b-col>
        <b-col cols="4">
          <span class="header-text">Phone number</span>
          <span>
            <vue-tel-input
              class="p-0 bg test-color"
              @onInput="onInputPhone"
              v-model="selectedMember.phoneNumber"
              :preferredCountries="['us', 'ca']"
              :placeholder="'(      )  '"
              v-bind:class="{
                input: true,
                'is-danger': selectedMember.phoneError
              }"
            ></vue-tel-input>
            <span v-if="selectedMember.phoneError" class="error-style">{{ selectedMember.phoneError }}</span>
          </span>
        </b-col>
      </b-row>
      <b-row class="pb-10 border-style blinded-lock">
        <div class="col-4 d-none" v-if="selectedMember.status === 'Active' && user.userRole === 'Pi' && user.username === selectedMember.username">
          <span class="un-bld-Lbl-Txt">Unblinded</span>
          <label class="switch">
            <input type="checkbox" v-model="selectedMember.blinded" />
            <div class="slider round"></div>
          </label>
          <span class="bld-Lbl-Txt">Blinded</span>
          <span class="info-msg">
            <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="hover" data-content="Enabling the toggle to <b>Blinded</b> will hide all participant responses from this team member. Disabling the toggle to <b>Unblinded</b> will allow this member to view all participant responses." data-html="true"></i>
          </span>
        </div>
        <b-col cols="4" class="ml-10" v-else>
          <span class="un-bld-Lbl-Txt">Unblinded</span>
          <label class="switch">
            <input type="checkbox" v-model="selectedMember.blinded" />
            <div class="slider round"></div>
          </label>
          <span class="bld-Lbl-Txt">Blinded</span>
          <span class="info-msg">
            <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content="Enabling the toggle to <b>Blinded</b> will hide all participant responses from this team member. Disabling the toggle to <b>Unblinded</b> will allow this member to view all participant responses." data-html="true"></i>
          </span>
        </b-col>
        <b-col cols="4" class="ml-10" v-if="(user.userRole === 'SystemAdmin' || user.userRole === 'StudyAdmin' || user.userRole === 'Support') && selectedMember.userRole != 'SiteDataLock'">
          <span class="un-bld-Lbl-Txt">Read-only</span>
          <span class="readonly-info">
            <span class="info-msg">
              <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content="When Read-only is turned on, the Site Team member will only be able to view information and will not be able to take any actions. This scenario is primarily used during the Close Out/Archiving phase of a clinical trial." data-html="true"></i>
            </span>
          </span>
          <span class="bld-Lbl-Txt">Off</span>
          <span class="ml-10">
            <label class="switch">
              <input type="checkbox" v-model="selectedMember.readOnly" />
              <div class="slider round"></div>
            </label>
          </span>
          <span class="bld-Lbl-Txt">On</span>
        </b-col>
      </b-row>
      <div class="row color_1e8fe1 pb-10 mt-10">
        <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle fs-7 ml-0 mr-5 pl-15 pt-4"></span>
        <span style="color:black;font-size:10px">indicates a required field</span>
      </div>
      <b-row class="pt-30" align-self="center" align-v="center" align-h="center" v-if="modalType === 'add'">
        <b-col class="pull-right">
          <b-btn variant="success" class="pull-right create-btn fs-14" @click="validateAddTeamBeforeSubmit()">Send Invite</b-btn>
          <b-link variant="primary" class="pull-right pt-8 fs-14 pr-20" @click="closeModal()">Cancel</b-link>
        </b-col>
      </b-row>
      <b-row class="pt-30" v-if="modalType === 'edit'">
        <b-col class="pull-left" cols="6" align-self="center">
          <b-link class="deactivate-member" @click="activateMember('Inactive')" v-if="modalType === 'edit' && (selectedMember.status == 'Active' || selectedMember.status == 'Pending') && ((selectedMember.userRole === 'Pi' && (canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canSupportAccess)) || selectedMember.userRole !== 'Pi')">Deactivate from site</b-link>
          <b-link class="deactivate-member" @click="activateMember('Active')" v-if="modalType === 'edit' && selectedMember.status == 'Inactive' && ((selectedMember.userRole === 'Pi' && (canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canSupportAccess) && !activePI) || selectedMember.userRole !== 'Pi')">Activate member</b-link>
        </b-col>
        <b-col class="pull-right" cols="6" v-if="!canAccessSSOUsername">
          <b-btn class="pull-right create-btn edit-update fs-14" @click="updateTeamMemDetail()">Update</b-btn>
        </b-col>
      </b-row>
      <div class="idp-username-section" v-if="modalType === 'edit' && canAccessSSOUsername">
        <div class="additional-details-sso">
          <span class="line"></span>
          <div class="additional-sso-title">Additional Details for SSO</div>
          <div class="desc">Important! Please do not populate this section unless this user’s account is associated with an SSO IdP.</div>
          <div class="row no-gutters">
            <div class="col-4 mr-16">
              <span class="header-text">IdP Username</span>
              <b-form-input type="text" class="bg test-color" v-model="selectedMember.idpUserName" placeholder="Enter IDP Username" name="idpUserName"></b-form-input>
            </div>
          </div>
        </div>
        <div class="submit-btn">
          <b-btn class="pull-right create-btn edit-update fs-14" @click="updateTeamMemDetail()">Update</b-btn>
        </div>
      </div>
      <div class="modal-style"></div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";
import cloneDeep from "lodash/cloneDeep";
import { SYSTEM_ADMIN, STUDY_ADMIN, PI, STUDY_MANAGER, SITEDATALOCK, SUPPORT } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import toastr from "toastr";

export default {
  name: "research-site",
  data() {
    return {
      selectedMember: {},
      countryCode: ""
    };
  },
  props: {
    siteId: String,
    studyId: String,
    modalType: String,
    activePI: Boolean,
    memberDetails: Object,
    title: String
  },
  computed: {
    ...mapGetters(["user", "awsCognitoAuthentication"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    canAccessSSOUsername() {
      if (this.awsCognitoAuthentication && this.awsCognitoAuthentication === true && (this.canSysAdminAccess || this.canStudyAdminAccess || this.canSupportAccess)) {
        return true;
      }
      return false;
    }
  },
  watch: {
    memberDetails: {
      handler() {
        if (this.modalType === "add") {
          this.selectedMember = {};
          this.errors.clear();
        } else {
          this.errors.clear();
          this.selectedMember = cloneDeep(this.memberDetails);
        }
      }
    }
  },
  mounted() {
    window.setTimeout(() => {
      window.$('[data-toggle="popover"]').popover();
    }, 1);
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onInputPhone({ number, isValid, country }) {
      this.selectedMember.phoneError = false;
      this.countryCode = country.dialCode;
      this.$forceUpdate();
      if (!isValid && number.length > 0) {
        this.selectedMember.phoneError = "Please enter a valid phone number.";
        this.$forceUpdate();
      } else {
        this.selectedMember.phoneError = false;
        this.$forceUpdate();
      }
    },

    validateAddTeamBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.selectedMember.phoneError) {
            this.$toastr.error(this.selectedMember.phoneError);
          } else {
            this.selectedMember.phoneNumber = this.selectedMember.phoneNumber ? this.selectedMember.phoneNumber.replace(/\s/g, "") : this.selectedMember.phoneNumber;
            this.$api.postSiteTeamMemberFact(this.studyId, this.siteId, this.selectedMember).then(
              () => {
                this.$emit("added");
                this.errors.clear();
                this.hide();
                this.selectedMember = {};
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
              }
            );
          }
        }
      });
    },

    updateTeamMemDetail() {
      const idpUserName = this.selectedMember.idpUserName;
      if (idpUserName && idpUserName.includes(" ")) {
        this.$toastr.error("IdP Username cannot contain spaces.");
        return;
      }
      if (idpUserName && idpUserName.length > 128) {
        this.$toastr.error("IdP Username should be 128 characters or less.");
        return;
      }
      if (idpUserName && idpUserName.length < 8) {
        this.$toastr.error("Invalid IdP username, this username cannot be saved");
        return;
      }
      if (idpUserName) {
        const specialCharactersRegex = /^[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]+$/;
        if (specialCharactersRegex.test(idpUserName.charAt(0)) || specialCharactersRegex.test(idpUserName.charAt(idpUserName.length - 1))) {
          this.$toastr.error("Invalid IdP username, this username cannot be saved");
          return;
        }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.selectedMember.phoneError) {
            this.$toastr.error(this.selectedMember.phoneError);
          } else {
            if (this.selectedMember.phoneNumber) {
              this.selectedMember.phoneNumber = `${this.selectedMember.phoneNumber
                .replace(this.countryCode, "")
                .replace(/\s/g, "")
                .replace(/[^a-zA-Z0-9 ]/g, "")}`;
              this.selectedMember.phoneNumber = `+${this.countryCode}${this.selectedMember.phoneNumber}`;
            }
            this.$api.editSiteUser(this.selectedMember.id, this.$route.params.siteId, this.selectedMember, this.studyId).then(
              () => {
                this.$emit("updated");
                this.$toastr.success("Team member updated successfully");
                this.errors.clear();
                this.hide();
                this.selectedMember = {};
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
              }
            );
          }
        }
      });
    },

    activateMember(status) {
      const data = {
        status
      };
      swal({
        title: status == "Inactive" ? "Are you sure you want to deactivate this Site team member from this Site?" : "Are you sure you want to activate this Site team member from this Site?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4c8ce4",
        cancelButtonColor: "#4c8ce4",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api.activateTeamMemberFact(this.selectedMember.id, this.siteId, this.studyId, data).then(
            () => {
              if (status === "Inactive") {
                this.$toastr.success("Team member deactivated successfully");
              }
              if (status === "Active") {
                this.$toastr.success("Team member activated successfully");
              }
              this.$emit("updated");
              this.hide();
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
            }
          );
        } else {
          this.hide();
        }
      });
    },

    closeModal() {
      this.$swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "No",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.hide();
          if (this.modalType === "add") {
            this.selectedMember = {};
          } else {
            this.selectedMember = cloneDeep(this.memberDetails);
          }
          this.errors.clear();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.header-text {
  color: #666669 !important;
  opacity: 0.5;
}

.modal-content {
  width: 800px !important;
}

/deep/ .modal-header {
  display: none;
  border-bottom: none !important;
  padding-left: 30px !important;
}

/deep/ .modal-title {
  font-weight: bold !important;
  padding-left: 15px !important;
}

.create-btn {
  border-radius: 100px;
  border: none;
  width: 120px;
  height: 35px;
}

.edit-update {
  background: #4c8ce4;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.deactivate-member {
  color: #f16559;
  opacity: 1 !important;
}

.is-danger {
  border-color: #ff4848;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 27px;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: 14px;
  right: 10px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: 14px;
  left: 5px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 15px;
  top: 14px;
}
.readonly-info {
  position: relative;
  right: 20px;
}
.blinded-lock {
  position: relative;
  bottom: 15px;
}
.required {
  background: url("/static/img/required.svg") no-repeat right #f5f8fa !important;
}
/* .caret {
  background: url("/static/img/caret-down.png") no-repeat right #f5f8fa !important;
} */
.test-color {
  color: #666669 !important;
}
/* .caret-down-icon{
  background-image: url(/static/img/caret-down.png);
  background-repeat: no-repeat;
} */
.select-arrow {
  background: url("/static/img/required.svg") no-repeat right, url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px #f5f8fa !important;
}
@media screen and (max-width: 768px) {
  .modal-content {
    width: auto !important;
  }
}

.idp-username-section {
  margin-top: 30px;
  .submit-btn {
    text-align: right;
    margin-bottom: 11px;
    padding-right: 24px;
    button {
      &.btn {
        &.btn-primary {
          position: inherit;
        }
      }
    }
  }
  .additional-details-sso {
    border-bottom: 1px solid #d4d4d3;
    margin-left: 13px;
    margin-right: 13px;
    margin-bottom: 25px;
    padding-bottom: 23px;

    .additional-sso-title {
      color: #4a4a4a;
      font-family: Roboto-Medium;
      font-size: 16px;
      display: flex;
      align-items: center;
      &::after {
        content: "";
        flex: 1;
        margin-left: 1rem;
        height: 1px;
        background-color: #d4d4d3;
        margin-top: 15px;
      }
    }
    .desc {
      margin-top: 16px;
      margin-bottom: 19px;
      color: #666669;
      font-family: Roboto-Regular;
      font-size: 12px;
    }

    input {
      background: #f5f8fa;
    }
  }
}
</style>
